import { render, staticRenderFns } from "./InkNote.vue?vue&type=template&id=71d06aee&scoped=true&"
import script from "./InkNote.vue?vue&type=script&lang=js&"
export * from "./InkNote.vue?vue&type=script&lang=js&"
import style0 from "./InkNote.vue?vue&type=style&index=0&id=71d06aee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d06aee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpeedDial } from 'vuetify/lib/components/VSpeedDial';
installComponents(component, {VBadge,VBtn,VCard,VCol,VContainer,VIcon,VRow,VSpeedDial})
